import { render, staticRenderFns } from "./page-toc.vue?vue&type=template&id=a63091c2"
import script from "./page-toc.vue?vue&type=script&lang=js"
export * from "./page-toc.vue?vue&type=script&lang=js"
import style0 from "./page-toc.vue?vue&type=style&index=0&id=a63091c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports